import { CreateService } from '@/services/service';
import { IssueCommentEntity } from '@/entities/issue-comment.entity';
import APIBuilder from '@quangphuc/frontend-api-builder';

export default class IssueCommentService extends CreateService<IssueCommentEntity>(
  'issue-comment',
) {
  async updateOne(
    id: number,
    instance: Partial<IssueCommentEntity>,
  ): Promise<IssueCommentEntity> {
    const { data } = await this.apiBuilder.updateOne(id, instance);
    return data;
  }
  async upload(id: number, instance: { file: File }): Promise<void> {
    if (!instance.file) return;
    const formData = new FormData();
    if (instance.file) {
      formData.append('file', instance.file);
    }
    await APIBuilder.axios.patch<IssueCommentEntity>(
      `${this.apiBuilder.$endpoint}/upload/${id}`,
      formData,
    );
  }
}
